module.exports = __webpack_public_path__ + "img/gl.de8cd621.png";